import isNonCacheableRoute from '../helpers/isNonCachableRoute';
import { FIVE_MINUTES_IN_SECONDS } from '../utils/cache-constants';

function buildCacheControlHeader(): string {
  // prettier-ignore
  return [
    'public',
    `s-maxage=${FIVE_MINUTES_IN_SECONDS}`,
    `max-age=${FIVE_MINUTES_IN_SECONDS}`,
    `stale-while-revalidate=${FIVE_MINUTES_IN_SECONDS}`,
  ].join(', ');
}

/**
 * Used by Next.js app middleware to set Cache-Control headers for cachable routes (ADR 0029, ADR 0041).
 *
 * The app middleware (e.g. apps/lottoland/uk/middleware.ts) calls this with the request pathname
 * and applies the returned header to the response. For pathnames that are non-cacheable
 * (e.g. /my-account, /time-off), returns undefined so no Cache-Control header is set.
 * For all other routes, the server response is cacheable for all users because authenticated
 * content on those pages is implemented with 'use client' and only the unauthenticated
 * shell is present in the cached HTML (see ADR 0041).
 *
 * @returns Header object or undefined for non-cacheable routes.
 */
function cacheControlHeaders(pathname: string): undefined | { header: string; value: string } {
  if (!pathname || isNonCacheableRoute(pathname)) {
    return undefined;
  }

  return {
    header: 'Cache-Control',
    value: buildCacheControlHeader(),
  };
}

export { cacheControlHeaders };
